import { H2 } from "pages/Pass-Form/stylePases";

const Descriptions = ({ values, formCorrected }) => {
  console.log(values);
  console.log(formCorrected);
  return (
    <>
      <div className="d-flex justify-content-between mt-5 ">
        <div className="d-flex ">
          <H2 className="fw-bold ">Tipo de cuadro:</H2>
          <span className="ms-2">
            {values?.destiny
              ? values?.destiny
              : formCorrected?.newData?.data?.destiny}
          </span>
        </div>
        {((values?.reentry_operation === 1) ||
          (values?.destiny && values?.destiny.includes('CT TEMPORALES')) ||
          (formCorrected?.newData?.data?.destiny && formCorrected?.newData?.data?.destiny.includes('CT TEMPORALES'))) && (
            <div className="d-flex flex-column">
              <div className="d-flex">
                <H2 className="fw-bold">Plazo de vencimiento:</H2>
                <span className="ms-2">
                  {values?.expiration_final_date || formCorrected?.newData?.data?.expiration_final_date || 'N/A'}
                </span>
              </div>
            </div>
          )}
      </div>

      <div className="d-flex justify-content-between mt-3">
        <div className="d-flex">
          <H2 className="fw-bold">Observación :</H2>
          <span className="ms-2">
            {values?.observations
              ? values?.observations
              : formCorrected?.newData?.data?.observations}
          </span>
        </div>
      </div>
    </>
  );
};

export default Descriptions;